import { ColchesterRecordType, ColchesterRecordSubType } from "./ColchesterRecordTypes";
import { IStyleFactory } from "@esdm/map/dist/layers/vector/styles/IStyleFactory";
import Style, { StyleFunction } from "ol/style/Style";
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import RegularShape from 'ol/style/RegularShape';

export class HbsmrStyleFactory implements IStyleFactory {

    public getStyle(recordType: string, recordSubType: string = null): Style[]
    {
        let style: Style[] = null;

        //try and resolve sub type first
        if (recordSubType !== null) {
            switch (recordSubType) {
                case ColchesterRecordSubType.ConservationArea:
                    style = this.ConservationArea();
                    break;

                case ColchesterRecordSubType.ListedBuilding:
                    style = this.ListedBuilding();
                    break;

                case ColchesterRecordSubType.ScheduledMonument:
                    style = this.ScheduledMonument();
                    break;
                              
                case ColchesterRecordSubType.RegisteredParksAndGardens:
                    style = this.RegisteredParksAndGardens();
                    break;

                case ColchesterRecordSubType.LocalList:
                    style = this.LocalList();
                    break;
            }
        }

        if (style === null) {
            switch (recordType) {
                case ColchesterRecordType.Monument:
                    style = this.Monument();
                    break;

                case ColchesterRecordType.Event:
                    style = this.Event();
                    break;

                case ColchesterRecordType.Designation:
                    style = this.Designation();
                    break;
            }
        }

        return style;
    }

    public getSelectedStyle(
        recordType: string = ColchesterRecordType.Monument): Style[]
    {        
        return this.SelectedRecord();
    }

    private CommonStyle(fillColour: string): Style[] {
        var fill = new Fill({
            color: fillColour
        });
        var stroke = new Stroke({
            color: 'rgba(255,255,255,1)',
            width: 3
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: stroke,
                    radius: 12
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    
    private Monument(): Style[] {      
        var fill = new Fill({
            //color: 'rgba(66, 94, 143,0.4)'
            color: 'rgba(0, 177, 176,0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(50,50,50,1)',
            width: 2
        });

        return   [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: stroke,
                    radius: 12
                }),
                fill: fill,
                stroke: stroke
            })
        ];

    }

    private Event(): Style[] {       
        var fill = new Fill({
            color: 'rgba(165, 42, 42, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(165, 42, 42, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 4,
                radius: 10,
                angle: Math.PI / 4
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private Designation(): Style[] {
        return this.CommonStyle('rgba(132, 71, 15,0.4)');
    }

    private ListedBuilding(): Style[] {
        var fill = new Fill({
            color: 'rgba(27, 15, 220, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(27, 15, 220, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 3,
                radius: 10,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ConservationArea(): Style[] {
        //return this.CommonStyle('rgba(27, 15, 220, 0.4)');   
        var fill = new Fill({
            color: 'rgba(255, 153, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(255, 153, 0, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ScheduledMonument(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 78, 78, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(226, 78, 78, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 3,
                radius: 10,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }
    
    private RegisteredParksAndGardens(): Style[] {
        //return this.CommonStyle('rgba(45, 123, 9,0.5)');   
        var fill = new Fill({
            color: 'rgba(63, 127, 71, 0.3)'
        });

        var stroke = new Stroke({
            color: 'rgba(63, 127, 71, 1)',
            width: 2
        });
                
        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private LocalList(): Style[] {
        var fill = new Fill({
            color: 'rgba(178, 0, 255, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(50,50,50,1)',
            width: 2
        });
       
        return [new Style({
            image: new RegularShape({
                fill: new Fill({ color: 'rgba(178, 0, 255, 0.4)' }),
                stroke: new Stroke({ color: 'rgba(50,50,50,1)', width: 2 }),
                points: 3,
                radius: 10,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private SelectedRecord(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 0, 0, 0.6)'
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: new Stroke({
                        color: 'rgba(255, 0, 0, 1)',
                        width: 3
                    }),
                    radius: 10
                }),
                fill: fill,
                stroke: new Stroke({
                    color: 'rgba(255, 0, 0, 1)',
                    width: 3
                })
            })
        ];
    }

}
